<template>
  <div>
    <div :class="
        sideBySide ? 'icard-container side-by-side' : 'icard-container stacked'
      " v-for="(icard_data, ind) in icard_data" :key="ind">
      <div v-if="icard_data !== ''" class="icard-wrapper">
        <img :src="common_data.watermark" class="watermark-bg" />
        <div class="content-layer">
          <center>
            <img :src="icard_data.profile_photo_path" class="profile-photo" />
          </center>
            <div class="pa-3 details">
              <b>Academic Year :-</b> <b>{{ icard_data.ay }}</b><br />
              <b>Name :-</b> <b>{{ icard_data.name }}</b><br />
              <b>Class :-</b> <b>{{ icard_data.std }}</b>
              <b class="ml-7">Div :-</b> <b>{{ icard_data.div }}</b><br />
              <b>PRN :-</b>
              <span v-if="icard_data.prn != null && icard_data.prn !== ''">
                <b>{{ icard_data.prn }}</b>
              </span><br />
              <b>G.R. No. :-</b>
              <span v-if="icard_data.grno !== null && icard_data.grno !== ''">
                <b>{{ icard_data.grno }}</b>
              </span><br />
              <b>Date of Birth :-</b> <b>{{ icard_data.stud_dob }}</b><br />
              <b>Blood Group :-</b> <b>{{ icard_data.stud_blood_group }}</b><br />
              <b>Mobile No. :-</b> <b>{{ icard_data.stud_contact }}</b>
            </div>
            <img class="sign-img" style=" position: absolute;right: -12px;" :src="common_data.sign" alt="sign"
              width="120" height="50" />
        </div>
      </div>

      <div v-if="icard_data !== ''" class="icard-wrapper">
        <img :src="common_data.watermark_back" class="watermark-bg" />
        <div class="content-layer">
           <div class="px-3 details">
            <b>Email ID :- </b> <span style="font-size: 12px;">{{ icard_data.email }} </span><br />

            <div style="min-height: 57px;">
              <b>Address :- </b><span> {{ icard_data.stud_address }}</span>
            </div>

            <b>Rules</b>
            <div>
              <ul style="font-size: 12px;">
                <li v-for="(i, index) in common_data.instruction" :key="index">
                  <b>{{ i.topic }}</b>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="qrcode">
            <qrcode-vue :value="icard_data.prn" :size="40"></qrcode-vue>
          </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import QrcodeVue from "qrcode.vue";
import VueBarcode from "vue-barcode";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

export default {
  props: {
    sideBySide: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    barcode: VueBarcode,
    QrcodeVue,
  },
  data: () => ({
    stud_data: null,
    comp_load: false,
    icard_data: [],
    ay: null,
    org_id: null,
    common_data: []
  }),
  mounted() {
    this.prn = JSON.parse(localStorage.getItem("prn"));
    this.onload();
  },
  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      const data = {
        learners: this.prn,
        for: "specific",
        usertype: "Student",
      };
      axios
        .post("/Icard/generateIcardCommon", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.icard_data = res.data.icard_data;
            this.common_data = res.data.common_data;
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          }
        })
        .catch((error) => {
          alert("Somthing went wrong!!!");
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
  },
};
</script>
<style scoped>
.icard-container.side-by-side {
  display: flex;
  flex-direction: row;
  gap: 50px;
}
@media (max-width: 600px) {
  .icard-container.side-by-side {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
}

.icard-container.stacked {
  display: flex;
  flex-direction: column;
}

img {
  display: block;
  margin: 0;
}

body {
  margin: 0;
  padding: 0;
}

.pagebreak {
  page-break-after: always;
}

.icard-wrapper {
  position: relative;
  width: 325px;
  height: 488px;
}

.watermark-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  object-fit: cover;
}

.content-layer {
  position: absolute;
  top: 170px;
  left: 0;
  width: 100%;
  /* height: 100%; */
  z-index: 2;
}

.details {
  font-size: 14px;
  line-height: 150%;
}

.sign-img {
  margin-top: -60px;
  position: absolute;
}
.profile-photo {
  width: 110px;
  height: 110px;
  object-fit: cover;
  border-radius: 50%;
  border: 2px solid black;
}


.trust-logo {
  width: 70px;
  height: 70px;
  filter: brightness(0) invert(1);
  /* object-fit: cover; */
  /* margin-bottom: 10px; */
}

.signature {
  position: absolute;
  right: 10px;
  bottom: 30px;
  width: 120px;
  height: 50px;
}
.qrcode {
  display: block !important;
  position: absolute !important;
  bottom: 20px !important;
  right: 20px !important;
  z-index: 2;
}



@media print {

  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }

  * {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
   ul {
    list-style-type: disc !important;
    padding-left: 20px;
  }

  .qrcode {
    display: block !important;
  } 

  .pagebreak {
    page-break-after: always;
  }
  .details {
    padding: 7px;
  }
  @page {
    margin: 0mm;
    size: 57mm 86mm;
    /* or adjust slightly */
  }
}
</style>
